import moment from "moment";

/**
 * Entidad Payment del API.
 * @typedef {Object} Payment
 * @property {string} id_payment
 * @property {number|string} [id_invoice]
 * @property {number|string} [id_user]
 * @property {string} [created_at] Momento en que el servidor recibió/sincronizó el pago (auditoría).
 * @property {string|null} [payment_at] Momento REAL en que se realizó el cobro.
 * @property {string|number} [total_payment]
 * @property {number} [status]
 * @property {string} [client_name]
 */

/**
 * Fecha efectiva del cobro. Usa payment_at; si no viene (endpoints legacy), cae a created_at.
 * No sobrescribe created_at del objeto recibido del API.
 * @param {{ payment_at?: string|null, created_at?: string|null }} payment
 * @returns {string|null|undefined}
 */
export const getPaymentDate = (payment) =>
  payment?.payment_at ?? payment?.created_at;

/**
 * Formatea la fecha real del cobro sin conversión de timezone.
 * payment_at / created_at son timestamps sin zona (hora local de negocio).
 * @param {string|null|undefined} date
 * @returns {string}
 */
export const formatPaymentDate = (date) => {
  if (!date) return "";
  return moment(date).format("DD-MM-YYYY HH:mm:ss");
};

export const formatNumber = (num) => {
  if (typeof number !== "number") {
    num = parseInt(num);
  }
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const formatDate = (date) => {
  let fecha = new Date(date);
  let day = fecha.getDate();
  let month = fecha.getMonth() + 1;
  let year = fecha.getFullYear();
  if (month < 10) {
    return `${day}-0${month}-${year}`;
  } else {
    return `${day}-${month}-${year}`;
  }
};

export const formatTimestamp = (timestamp) => {
  let date = new Date(timestamp);
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var min = date.getMinutes();
  var sec = date.getSeconds();

  month = (month < 10 ? "0" : "") + month;
  day = (day < 10 ? "0" : "") + day;
  hour = (hour < 10 ? "0" : "") + hour;
  min = (min < 10 ? "0" : "") + min;
  sec = (sec < 10 ? "0" : "") + sec;

  var str =
    date.getFullYear() +
    "-" +
    month +
    "-" +
    day +
    " " +
    hour +
    ":" +
    min +
    ":" +
    sec;
  return str;
};

export const formatDateToUTC = (date) => {
  return moment(date).utc().format("DD-MM-YYYY HH:mm:SS")
};
